module.exports = __webpack_public_path__ + "img/8th_military.21878aef.webp";